// extracted by mini-css-extract-plugin
export var active = "Carousel-module--active--1bfec";
export var dot = "Carousel-module--dot--edbec";
export var dots = "Carousel-module--dots--9df06";
export var splideCaseStudy = "Carousel-module--splideCaseStudy--e7da6";
export var splideVersion2 = "Carousel-module--splideVersion2--87e53";